/**
 * Return a string like 2024-10
 * For january it will return 2024-01
 */
export function formatDateToYearMonth(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-11
  return `${year}-${month}`;
}
